import clsx from 'classnames'

import NoDataIcon from '../../../../assets/svgs/no-data-icon.svg?component'

import styles from './no-data-placeholder.module.css'

interface NoDataPlaceholderProps {
  title?: string
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export function NoDataPlaceHolder ({
  title = 'No data',
  children,
  className,
  style
}: NoDataPlaceholderProps): JSX.Element {
  return (
    <div
      className={clsx(className, styles.wrapper)}
      style={style}
    >
      <div className={styles.container}>
        <NoDataIcon style={{ transform: 'scale(0.8)' }} />

        <div className={styles.text}>
          {title}
        </div>

        <div className={styles.children}>
          {children}
        </div>
      </div>
    </div>
  )
}
